//#region imports
import { AfterViewInit, Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '@app/member-response-portal/components/confirm-dialog/confirm-dialog.component';
import { NOT_APPLICABLE, COLORS } from '@app/member-response-portal/model/constants';
import { EnterpriseInputBaseComponent, ToggleOption, YESNOU_NO, YESNOU_YES } from '@rawlings/enterprise-form';
import { MemberResponseHelper } from '../../member-response-helper';
//#endregion imports
@Component({
  selector: 'app-toggle-confirm-dialog',
  templateUrl: './toggle-confirm-dialog.component.html',
  styleUrls: ['./toggle-confirm-dialog.component.scss'],
})
export class ToggleConfirmDialogComponent extends EnterpriseInputBaseComponent implements AfterViewInit{
    //#region Inputs, Outputs, ViewChilds
    @Input() public get ShowButtonU(): boolean {
        return this._showButtonU;
    }
    public set ShowButtonU(value: boolean) {
        this._showButtonU = value;
    }
    @Input() public ConfirmDialogMessage: string;
    @Input() public ConfirmDialogSubtitle: string;
    @Input() public ConfirmDialogTitle: string;
    @Input() public ShowLabel: boolean = true;
    @Input() public ShowConfirmDialogForYES: boolean = false;
    @Input() public ShowConfirmDialogForNO: boolean = true;
    @Input() public ShowConfirmDialogForU: boolean = false;
    @Input() public SkipModal: boolean = false;
    @Input() public SkipModalWithEmit: boolean = false;
    //@Output() public Change: EventEmitter<MatButtonToggleChange> = new EventEmitter<MatButtonToggleChange>();
    @Output() public Change : EventEmitter<{ IsChecked: boolean; IsConfirmed: boolean }> = new EventEmitter<{ IsChecked: boolean; IsConfirmed: boolean }>();

    //#endregion Inputs, Outputs, ViewChilds

    //#region Public Variables
    public ToggleOptions: ToggleOption[] =[];
    //#endregion Public Variables

    //#region Private Variables
    private readonly yesToggle: ToggleOption = new ToggleOption(YESNOU_YES, COLORS.machinify_green, COLORS.machinify_black);
    private readonly noToggle: ToggleOption = new ToggleOption(YESNOU_NO, COLORS.machinify_red, COLORS.machinify_off_white);
    private readonly uToggle: ToggleOption = new ToggleOption(NOT_APPLICABLE, COLORS.machinify_red, COLORS.machinify_off_white);
    private _showButtonU: boolean = false;
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor and Angular Life Cycle
    /**
     * Standard control constructor that bind this component to
     * an angular from control. This will probably never be called by user code
     * but by the angular forms infrastructure.
     *
     * @param NgControl
     */
    constructor(@Self() @Optional() public NgControl: NgControl, private MatDialog: MatDialog) {
        super(NgControl);
    }

    public ngAfterViewInit(): void {
        this.ToggleOptions = [this.yesToggle, this.noToggle];
        if (this.ShowButtonU) {
            this.ToggleOptions.push(this.uToggle);
        }
    }
    //#endregion Constructor and Angular Life Cycle

    //#region Event Handlers
    public OnChange(event: MatButtonToggleChange): void {
        const isChecked : boolean = MemberResponseHelper.GetBoolFromYesNoValue(event.value);

        if(this.ShowConfirmDialogForYES && isChecked === true ){
            this.ShowConfirmDialog(isChecked);
        }
        else if(this.ShowConfirmDialogForNO && isChecked === false ){
            if (this.SkipModalWithEmit){
                this.Change.emit({IsChecked: isChecked, IsConfirmed:true});
                return;
            }
            this.ShowConfirmDialog(isChecked);
        }
        else if(this.ShowConfirmDialogForU && isChecked === null ){
            if (this.SkipModalWithEmit){
                this.Change.emit({IsChecked: isChecked, IsConfirmed:true});
                return;
            }
            this.ShowConfirmDialog(isChecked);
        }
        else {
            this.Change.emit({IsChecked: isChecked, IsConfirmed:true});
        }
    }
    //#endregion Event Handlers

    //#region Public Methods
    //#endregion Public Methods

    //#region Private Methods
    private ShowConfirmDialog(isChecked : boolean) : void{
        if(this.SkipModal || this.SkipModalWithEmit){
            return;
        }

        const dialogRef : any = this.MatDialog.open(ConfirmDialogComponent, {
            disableClose: true,
            data: { message : this.ConfirmDialogMessage,
                    subtitle: this.ConfirmDialogSubtitle,
                    title: this.ConfirmDialogTitle
            }
        });

        dialogRef.afterClosed().subscribe((result:boolean) =>{
            this.Change.emit({IsChecked: isChecked, IsConfirmed:result});
        });
    }
    //#endregion Private Methods

}
